// extracted by mini-css-extract-plugin
export default {"timeElement":"SpISLutNtd0ia1ZLbdHp","sameTime":"ej9h3YuKViNU0VtzWKFu","hideTime":"z5qfYxH0Pcr2m6699Ckv","active":"rEOGAzsYGwEezkKcAxWD"};